import { EzEnumeration2 } from '/ezlibrary/enums/EzEnumeration2.js';

import { EzErrorCode } from '/ezlibrary/enums/EzErrorCode.js';

/**
 * Represents the status of a validation response
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import into non-enumeration classes with:
 *      import {
 *          // ... other imported enumeration classes,
 *          EzValidationResponseStatus
 *      } from '/ezlibrary/enums/Enumerations.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import into other enumeration classes with:
 *      import { EzValidationResponseStatus } from '/ezlibrary/enums//EzValidationResponse.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
export class EzValidationResponseStatus extends EzEnumeration2 {
    /**
     * @private @field
     * Stores the singleton instance of this enumeration class.
     * @type {EzRegistrationState}
     */
    static #ezEnumerationSingleton = null;

    /**
     * @static
     * Static Initialization
     */
    static {
        if (null == EzValidationResponseStatus.#ezEnumerationSingleton) {
            EzValidationResponseStatus.#ezEnumerationSingleton = new EzValidationResponseStatus(
                // Enum property names
                [
                    'UNKNOWN',
                    'VALID',
                    'ERROR',
                    'WARNING',
                    'ERROR_UNSUPPORTED'
                ],
                // Enum property values for each enum property name as an array
                // Enter null if the values are equal to the names
                null,
                // Optional array of additional data for eac enumeration property.
                // Enter null if not needed.
                [
                    {
                        display: 'Unknown',
                        errorCode: EzErrorCode.UNKNOWN
                    },
                    {
                        display: 'Valid',
                        errorCode: EzErrorCode.NONE
                    },
                    {
                        display: 'Error',
                        errorCode: EzErrorCode.INTERNAL
                    },
                    {
                        display: 'Warning',
                        errorCode: EzErrorCode.WARNING
                    },
                    {
                        display: 'Unsupported',
                        errorCode: EzErrorCode.UNSUPPORTED
                    }
                ]);
        }
    }

    /**
     * @static
     * @public @method
     * Gets the display string for the provided enumValue
     * @returns {number}
     */
    static ezToErrorCode(enumValue) {
        return EzValidationResponseStatus.ezEnumData(enumValue).errorCode;
    }

    /**
     * @static
     * @public @method
     * Gets the display string for the provided enumValue
     * @returns {string}
     */
    static ezToDisplay(enumValue) {
        return EzValidationResponseStatus.ezEnumData(enumValue).display;
    }
}
